import { Grid } from '@chakra-ui/react'
import TabbedDisplay from 'modules/TabbedDisplay'
import EpidemiologyDashboard from '../BioriskMpox/Epidemiology'
import LatestAnalysisNews from '../BioriskMpox/LatestAnalysisNews'
import { BotulismPages } from 'config/apps/Botulism/BotulismPages'
import DiseasePipeline from '../BioriskMpox/Pipeline'
import GuidelineTable from './GuidelineTable'
import ClinicalTrialsDashboard from './ClinicalTrialsDashboard'

const BotulismTabs = () => {
  const pipelinePage = BotulismPages['BioriskBotulismPipeline']
  const approvalsPage = BotulismPages['BioriskApprovals']
  const pipelineTablePage = BotulismPages['BioriskBotulismPipelineTable']
  return (
    <TabbedDisplay
      minHeight='39px'
      tabListWrapper={(props) => (
        <Grid
          templateColumns='repeat(5, 1fr)'
          gap={2}
          width='100%'
          {...props}
        />
      )}
      tabs={[
        {
          heading: 'Latest Analysis & News',
          body: <LatestAnalysisNews disease='Botulism' />,
        },
        {
          heading: 'Epidemiology',
          body: <EpidemiologyDashboard disease='Botulism' />,
        },
        {
          heading: 'Guidelines',
          body: <GuidelineTable />,
        },
        {
          heading: 'Competitive Landscape',
          body: (
            <DiseasePipeline
              disease='Botulism'
              pages={{ pipelinePage, approvalsPage, pipelineTablePage }}
            />
          ),
        },
        {
          heading: 'Clinical Trials',
          body: <ClinicalTrialsDashboard />,
        },
      ]}
    />
  )
}

export default BotulismTabs
